import tmhRequest from '@/config/tmhRequest'


export default {
    searchSettlementDetailReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/settlementdetailreport/searchsettlementdetailreportcount',
            method: 'post',
            data: data,
        })
    },
    searchSettlementDetailReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/settlementdetailreport/searchsettlementdetailreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportSettlementDetailReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/settlementdetailreport/exportsettlementdetailreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/settlementdetailreport.js